var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtensivoR1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 285,
    height: 128,
    viewBox: "0 0 285 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_53",
    "data-name": "Ret\\xE2ngulo 53",
    width: 275.457,
    height: 61.21,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3891",
    "data-name": "Grupo 3891",
    transform: "translate(-634.968 -933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59",
    "data-name": "Grupo 59",
    transform: "translate(639.968 966)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_51",
    "data-name": "Ret\\xE2ngulo 51",
    width: 52.844,
    height: 60.373,
    transform: "translate(222.613 0.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_112",
    "data-name": "Caminho 112",
    d: "M0,2.956V31.118H21.189V24.392H8.48v-4.6H18.754V13.54H8.48V9.455H21.189v-6.5Z",
    transform: "translate(0 -2.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_113",
    "data-name": "Caminho 113",
    d: "M174.481,2.956l-8.186,13.063,9.486,15.1H165.721l-5.2-8.869-5.249,8.869h-7.911l9.072-14.542-8.7-13.62h10.083l4.369,7.579,4.535-7.579Z",
    transform: "translate(-125.764 -2.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_114",
    "data-name": "Caminho 114",
    d: "M351.335,9.7V31.118h-8.191V9.7h-5.839V2.956h19.868V9.7Z",
    transform: "translate(-287.872 -2.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_115",
    "data-name": "Caminho 115",
    d: "M510.816,24.392v6.726H489.627V2.956h21.189v6.5H498.107V13.54h10.275v6.251H498.107v4.6Z",
    transform: "translate(-417.87 -2.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58",
    "data-name": "Grupo 58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_57",
    "data-name": "Grupo 57",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_116",
    "data-name": "Caminho 116",
    d: "M681.653,31.118h-7.035L666.9,18.675a47.429,47.429,0,0,1-2.995-5.816,19.6,19.6,0,0,1,.681,4.621V31.118h-7.015V2.956h8.17l6.562,10.315a39.8,39.8,0,0,1,2.97,5.406,40.953,40.953,0,0,1-.66-7.386V2.956h7.035Z",
    transform: "translate(-561.205 -2.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_117",
    "data-name": "Caminho 117",
    d: "M835.521,20.445,843.547,19q1.01,3.4,5.2,3.4,3.26,0,3.26-1.733a1.608,1.608,0,0,0-.753-1.413,8.082,8.082,0,0,0-2.693-.9q-7.408-1.42-9.512-3.71a7.7,7.7,0,0,1-2.1-5.387,8.431,8.431,0,0,1,3.023-6.624Q842.989,0,848.663,0q8.6,0,11.368,6.912l-7.159,2.166a4.379,4.379,0,0,0-4.518-2.827q-2.827,0-2.826,1.754a1.386,1.386,0,0,0,.64,1.217,7.819,7.819,0,0,0,2.476.824,52.34,52.34,0,0,1,7.181,1.891,7.738,7.738,0,0,1,3.548,2.815,7.867,7.867,0,0,1,1.423,4.7,8.321,8.321,0,0,1-3.466,6.927,14.571,14.571,0,0,1-9.1,2.653q-10.3,0-12.709-8.583",
    transform: "translate(-713.072 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_52",
    "data-name": "Ret\\xE2ngulo 52",
    width: 8.645,
    height: 28.162,
    transform: "translate(151.024 0.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_118",
    "data-name": "Caminho 118",
    d: "M1133.875,2.956l-8.739,28.162h-8.81l-9.138-28.162h9.11l4.456,15.35q.456,1.362.809,2.682l5.2-18.032Z",
    transform: "translate(-944.925 -2.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_119",
    "data-name": "Caminho 119",
    d: "M1306.623,29.029a12.761,12.761,0,0,1-9.686-3.941q-3.745-3.94-3.745-10.543a15.317,15.317,0,0,1,3.58-10.429Q1300.351,0,1306.706,0a12.657,12.657,0,0,1,9.583,3.879q3.7,3.879,3.7,10.357,0,6.706-3.734,10.749a12.52,12.52,0,0,1-9.635,4.044m-.041-6.4a3.269,3.269,0,0,0,3.147-1.909q.959-1.908.959-6.984,0-7.345-3.941-7.345-4.25,0-4.25,8.376,0,7.861,4.085,7.861",
    transform: "translate(-1103.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_120",
    "data-name": "Caminho 120",
    d: "M22.322,237.8v25.96H14.354v-10.1H8.268v10.1H.3V237.8H8.268v9.547h6.086V237.8Z",
    transform: "translate(-0.255 -202.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_121",
    "data-name": "Caminho 121",
    d: "M183.211,263.758l-1.467-5.116h-6.954l-1.559,5.116h-6.469l8.014-25.96H183.2l8.142,25.96Zm-7.067-10.783h4.2l-2.1-7.531Z",
    transform: "translate(-142.321 -202.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_122",
    "data-name": "Caminho 122",
    d: "M373.914,263.758H365.08l-3.792-9.928h-2.513v9.928h-7.969V237.8h13.56a10.475,10.475,0,0,1,6.97,2.1,6.908,6.908,0,0,1,2.482,5.544,8.335,8.335,0,0,1-.913,3.965,7.685,7.685,0,0,1-3.689,3.034Zm-15.139-15.481h3.4a4.189,4.189,0,0,0,2.415-.628,2.1,2.1,0,0,0,.913-1.845q0-2.491-3.062-2.491h-3.671Z",
    transform: "translate(-299.395 -202.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_123",
    "data-name": "Caminho 123",
    d: "M534.172,263.758V237.8h10.042q6.542,0,9.794,3.88a13.561,13.561,0,0,1,3.252,8.977,13.11,13.11,0,0,1-3.49,9.462,11.986,11.986,0,0,1-9.062,3.642Zm7.969-5.972h2.073a4,4,0,0,0,3.338-1.921,8.9,8.9,0,0,0,1.36-5.23,9.477,9.477,0,0,0-1.208-4.888,3.83,3.83,0,0,0-3.49-2.054h-2.073Z",
    transform: "translate(-455.887 -202.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_124",
    "data-name": "Caminho 124",
    d: "M735.573,237.8l-6.885,25.96h-6.694l-3.632-14.321-3.429,14.321h-6.98l-6.9-25.96h7.5l3.631,14.941,3.542-14.941h6.256l3.854,14.971,3.637-14.971Z",
    transform: "translate(-598.312 -202.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_125",
    "data-name": "Caminho 125",
    d: "M954.029,261.832A11.764,11.764,0,0,1,945.1,258.2q-3.452-3.632-3.452-9.718a14.119,14.119,0,0,1,3.3-9.614q3.3-3.794,9.157-3.794a11.668,11.668,0,0,1,8.834,3.575q3.413,3.576,3.414,9.547,0,6.181-3.442,9.909a11.541,11.541,0,0,1-8.881,3.728m-.038-5.9a3.012,3.012,0,0,0,2.9-1.759q.884-1.759.884-6.438,0-6.77-3.633-6.77-3.918,0-3.918,7.721,0,7.246,3.766,7.246",
    transform: "translate(-803.646 -200.622)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_126",
    "data-name": "Caminho 126",
    d: "M1156.3,263.758h-8.834l-3.792-9.928h-2.513v9.928h-7.969V237.8h13.56a10.474,10.474,0,0,1,6.97,2.1,6.908,6.908,0,0,1,2.482,5.544,8.332,8.332,0,0,1-.913,3.965,7.685,7.685,0,0,1-3.689,3.034Zm-15.139-15.481h3.4a4.189,4.189,0,0,0,2.415-.628,2.1,2.1,0,0,0,.913-1.845q0-2.491-3.062-2.491h-3.671Z",
    transform: "translate(-967.115 -202.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_127",
    "data-name": "Caminho 127",
    d: "M1339.964,263.758h-8.719l-4.488-9.81-2.692,3.82v5.991h-7.512V237.8h7.512v10.734l7.159-10.734h7.162l-6.556,9.5Z",
    transform: "translate(-1123.607 -202.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_128",
    "data-name": "Caminho 128",
    d: "M1562.366,61.652l8.138,15.86h-8.611l-7-14.444h-1.083V77.512h-7.861v-54.5h11.444q10.471.028,10.472,11.472V51.6q0,7.222-5.5,10.055m-8.555-30.915V55.569h1.806a7.574,7.574,0,0,0,2.25-.222A3.373,3.373,0,0,0,1560,51.875V34.459q0-3.722-3.417-3.722Z",
    transform: "translate(-1319.385 -19.642)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_129",
    "data-name": "Caminho 129",
    d: "M1751.284,72.659V26.189l-7.361,1.389V20.106l15.222-2.778v55.33Z",
    transform: "translate(-1488.344 -14.789)"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1664",
    "data-name": "Ret\\xE2ngulo 1664",
    width: 285,
    height: 128,
    transform: "translate(634.968 933)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensivoR1);
export default __webpack_public_path__ + "static/media/extensivoR1.8ce6028ff9a7b313dc1c76f9db98b73d.svg";
export { ForwardRef as ReactComponent };